module.exports = "/_next/static/images/Hero-e637457bb0f73cffd5d393bcf3af9716.webp";